// HOW-SLOTS-WEB-AGENDA-TASKS (2026-07-09): agenda items keyed by coordination-object id (the
// FE's aliased int id -- same key space as activeTeeup.id / teeupPeople, see
// src/utils/devBackendShim.js aliasId). Per-CO slice: { loading, items, error }.
import actionTypes from "@actions/actionTypes"

export const initialState = {
  byCoId: {},
}

const coSlice = (state, coId) => state.byCoId[coId] || { loading: false, items: [], error: null }

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENDA_SET_LOADING: {
      const { coId, loading } = action.payload
      return {
        ...state,
        byCoId: {
          ...state.byCoId,
          [coId]: { ...coSlice(state, coId), loading },
        },
      }
    }
    case actionTypes.AGENDA_SET_ITEMS: {
      const { coId, items } = action.payload
      return {
        ...state,
        byCoId: {
          ...state.byCoId,
          [coId]: { loading: false, items, error: null },
        },
      }
    }
    case actionTypes.AGENDA_ITEM_UPSERTED: {
      const { coId, item } = action.payload
      const slice = coSlice(state, coId)
      const exists = slice.items.some(i => i.id === item.id)
      const items = exists
        ? slice.items.map(i => (i.id === item.id ? { ...i, ...item } : i))
        : [...slice.items, item].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
      return { ...state, byCoId: { ...state.byCoId, [coId]: { ...slice, items } } }
    }
    case actionTypes.AGENDA_ITEM_REMOVED: {
      const { coId, itemId } = action.payload
      const slice = coSlice(state, coId)
      return {
        ...state,
        byCoId: {
          ...state.byCoId,
          [coId]: { ...slice, items: slice.items.filter(i => i.id !== itemId) },
        },
      }
    }
    case actionTypes.AGENDA_REORDERED: {
      const { coId, items } = action.payload
      const slice = coSlice(state, coId)
      return { ...state, byCoId: { ...state.byCoId, [coId]: { ...slice, items } } }
    }
    default:
      return state
  }
}
